import React from 'react';
import HeroTradioraSection from '../components/hero/HeroTradioraSection';
import AppFeatures from '../components/features/AppFeatures';
import HowItWorks from '../components/how-it-works/HowItWorks';
import UseCases from '../components/use-cases/UseCases';
import Comparison from '../components/comparison/Comparison';
import SecuritySection from '../components/security/SecuritySection';
import ComingSoon from '../components/coming-soon/ComingSoon';
import Download01 from '../components/download/Download01';

function HomeOne() {
  return (
    <div className="home-1">
      <HeroTradioraSection />
      <AppFeatures />
      <HowItWorks />
      <UseCases />
      <Comparison />
      <SecuritySection />
      <ComingSoon />
      <Download01 />
    </div>
  );
}

export default HomeOne;
